import { Component } from '@angular/core';

@Component({
  selector: 'app-archived-companies-data-empty',
  templateUrl: './archived-companies-data-empty.component.html',
  styleUrls: ['./archived-companies-data-empty.component.scss']
})
export class ArchivedCompaniesDataEmptyComponent {

}
